import { Component } from '@angular/core';

@Component({
    selector: 'key-listing-title',
    templateUrl: './listing-title.component.html',
    standalone: false
})
export class KeyListingTitleComponent {
}
